var _path, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcNotificationV2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#005993",
    d: "M12.385 21c1.02 0 1.846-.826 1.846-1.846h-3.692c0 1.02.826 1.846 1.846 1.846zM17.923 15.461v-4.615c0-2.838-1.51-5.206-4.154-5.834v-.627c0-.767-.618-1.385-1.384-1.385C11.618 3 11 3.618 11 4.385v.627c-2.645.628-4.154 2.996-4.154 5.834v4.615L5 17.308v.923h14.77v-.923l-1.847-1.847z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17.5,
    cy: 6.5,
    r: 3.5,
    fill: "#D71249"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcNotificationV2);
export default __webpack_public_path__ + "static/media/ic_notification_v2.38fdae9e5b475f95fbaed13feba72e88.svg";
export { ForwardRef as ReactComponent };